import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_11: FaireProductEntity = {
  token: "catalog_prod_prod-11",
  type: "product",
  name: "Cupcake Toppers - Assorted Celebration",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 102.9,
  msrpDollars: 257.25,
  sku: "CO0011",
  caseSize: 2,
  material: "Ceramic",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 287,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
